import { useChargeDetailVM } from "presentation/hook/ChargeDetailMaintenance/useChargeDetailVM";
import { ChargeDetailModel } from "presentation/model/ChargeDetailMaintenance/ChargeDetailModel";
import NumberInputComponent from "presentation/view/components/NumberInputComponent";
import { useCallback, useMemo } from "react";
import { InputField } from "veronica-ui-component/dist/component/core";

export const ImcoGrossWtAccordion = ({ chargeDetailState }: { chargeDetailState: ChargeDetailModel }) => {
    const chargeBatchUpdate = chargeDetailState.chargeBatchUpdate
    const chargeDetailVM = useChargeDetailVM();

    const onNumberFieldChange = useCallback((event: React.ChangeEvent<HTMLInputElement>, fieldName: string) => {
        chargeDetailVM.onInputTextChange(event, fieldName, chargeBatchUpdate, 'chargeBatchUpdate');
    }, [chargeDetailVM, chargeBatchUpdate]);

    const hideGrossWt = useMemo(() => {
        const chargeTypeList = chargeBatchUpdate.tmpChargeTypeSubChargeType ?? [];
        if (chargeTypeList.length > 0) {
            const ret = chargeTypeList.some(type => type !== 'CY');
            if (ret) {
                return true;
            }
        }
        return false;
    }, [chargeBatchUpdate.tmpChargeTypeSubChargeType])

    return (
        <>
            <div className={'im-flex-row'} style={{ marginBottom: '24px' }}>
                <div className='im-flex-row-item'>
                    <InputField
                        label='IMCO'
                        width='150px'
                        type="text"
                        value={chargeBatchUpdate.imcoCode1 || ''}
                        onChange={(e: any) => chargeDetailVM.onInputTextChange(e, 'imcoCode1', chargeBatchUpdate, 'chargeBatchUpdate')}
                        allowedSpecialChars={'all'} />
                </div>
            </div>

            {!hideGrossWt &&
                <div className={'im-flex-row'} style={{ marginBottom: '24px' }}>
                    <div className='im-flex-row-item'>
                        <NumberInputComponent
                            label={`Gross Wt.`}
                            width='150px'
                            fieldName={"grossWt"}
                            value={chargeBatchUpdate.grossWt || ''}
                            disabled={false}
                            decimalPlaces={2}
                            onChange={(e: any) => onNumberFieldChange(e, 'grossWt')}
                        />
                    </div>
                </div>}
        </>
    )
}